import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class Md5BypassService {
  private getHourlyTimestamp(date?: Date): string {
    const now = date || new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    return `${year}-${month}-${day}-${hour}`;
  }

  generateMd5Hash(customDate?: Date): string {
    if (!environment.md5Config?.secretPhrase) {
      throw new Error('No se ha configurado una frase secreta para MD5');
    }
    const hourlyTimestamp = this.getHourlyTimestamp(customDate);
    const combinedPhrase = `${environment.md5Config.secretPhrase}-${hourlyTimestamp}`;
    return CryptoJS.MD5(combinedPhrase).toString();
  }

  checkMd5Bypass(): boolean {
    try {
      if (!environment.md5Config) return false;

      const urlParams = new URLSearchParams(window.location.search);
      const providedHash = urlParams.get(environment.md5Config.urlParamName);
      if (!providedHash) return false;

      const currentHash = this.generateMd5Hash();
      if (providedHash === currentHash) return true;

      const previousHour = new Date();
      previousHour.setHours(previousHour.getHours() - 1);
      const previousHash = this.generateMd5Hash(previousHour);
      return providedHash === previousHash;
    } catch {
      return false;
    }
  }

  generateBypassUrl(baseUrl?: string): string {
    const currentUrl = baseUrl || window.location.origin + window.location.pathname;
    const hash = this.generateMd5Hash();
    const paramName = environment.md5Config?.urlParamName || 'dev_tools';
    const separator = currentUrl.includes('?') ? '&' : '?';
    return `${currentUrl}${separator}${paramName}=${hash}`;
  }
}
